import type { Color } from "@pdfking/math"

export type PrintLayer =
  | {
      enum: "overlay"
      order: number
      guide_color?: Color
      print_color: Color
      print_roughness: number
    }
  | {
      enum: "print"
      order: number
    }
